import ReactFlow, { MiniMap, Controls, Background, MarkerType } from 'react-flow-renderer';
import { withNamespaces } from 'react-i18next';

const nodeStyles = {
    globalUltimate: { background: '#388e3c', color: '#fff', border: '2px solid #4caf50', borderRadius: 10 },  
    domesticUltimate: { background: '#388e3c', color: '#fff', border: '2px solid #4caf50', borderRadius: 10 }, 
    parent: { background: '#388e3c', color: '#fff', border: '2px solid #4caf50', borderRadius: 10 },           
    currentCompany: { background: '#1976d2', color: '#fff', border: '2px solid #1976d2', borderRadius: 10 },  
    branch: { background: '#9C27B0', color: '#fff' }           
};

const generateNodes = ({
    t,
    globalUltimate,
    domesticUltimate,
    parent,
    currentCompany
}) => {
    const nodes = [
        {
            id: 'globalUltimate',
            type: 'default',
            data: { label: `${t('Global Ultimate')}\n${globalUltimate.trade_name}\nDUNS: ${globalUltimate.duns}` },
            position: { x: 250, y: 0 },
            style: nodeStyles.globalUltimate
        },
    ];

    if (domesticUltimate.duns === parent.duns) {
        nodes.push(
            {
                id: 'parent',
                type: 'default',
                data: { label: `${t('Parent / Domestic')}\n${parent.trade_name}\nDUNS: ${parent.duns}` },
                position: { x: 250, y: 200 },
                style: nodeStyles.parent
            }
        )
    }
    else {
        nodes.push(
            {
                id: 'domesticUltimate',
                type: 'default',
                data: { label: `${t('Domestic Ultimate')}\n${domesticUltimate.trade_name}\nDUNS: ${domesticUltimate.duns}` },
                position: { x: 350, y: 130 },
                style: nodeStyles.domesticUltimate
            }
        )

        nodes.push(
            {
                id: 'parent',
                type: 'default',
                data: { label: `${t('Parent')}\n${parent.trade_name}\nDUNS: ${parent.duns}` },
                position: { x: 250, y: 270 },
                style: nodeStyles.parent
            }
        )
    }

    nodes.push(
        {
            id: 'currentCompany',
            type: 'default',
            data: { label: `${t('This Company')}\n${currentCompany.trade_name}\nDUNS: ${currentCompany.duns}` },
            position: { x: 350, y: 390 },
            style: nodeStyles.currentCompany
        }
    );

    return nodes;
    // return [
    //     // ...linkage.branches.map((branch, index) => ({
    //     //     id: `branch-${index}`,
    //     //     type: 'default',
    //     //     data: { label: `Branch\n${branch.tradeName}\nDUNS: ${branch.duns}` },
    //     //     position: { x: 100 + index * 200, y: 400 },
    //         // style: nodeStyles.branch
    //     // })),
    // ]
}

const generateEdges = ({
    parent,
    domesticUltimate
}) => {
    const edges = [];

    if (domesticUltimate.duns === parent.duns) {
        edges.push(
            {
                id: 'e1',
                source: 'globalUltimate',
                target: 'parent',
                animated: true,
                arrowHeadType: 'arrowclosed',
                markerEnd: { type: MarkerType.Arrow, color: "#555" },
                style: {
                    stroke: "#555",  // arrow color
                    strokeWidth: 1.5,  // thickness (default is 1)
                }
            }
        )

        edges.push(
            {
                id: 'e2',
                source: 'parent',
                target: 'currentCompany',
                animated: true,
                arrowHeadType: 'arrowclosed',
                markerEnd: { type: MarkerType.Arrow, color: "#555" },
                style: {
                    stroke: "#555",  // arrow color
                    strokeWidth: 1.5,  // thickness (default is 1)
                }
            }
        )
    }
    else {
        edges.push(
            {
                id: 'e1',
                source: 'globalUltimate',
                target: 'domesticUltimate',
                animated: true,
                arrowHeadType: 'arrowclosed',
                markerEnd: { type: MarkerType.Arrow, color: "#555" },
                style: {
                    stroke: "#555",  // arrow color
                    strokeWidth: 1.5,  // thickness (default is 1)
                }
            }
        )

        edges.push(
            {
                id: 'e2',
                source: 'domesticUltimate',
                target: 'parent',
                animated: true,
                arrowHeadType: 'arrowclosed',
                markerEnd: { type: MarkerType.Arrow, color: "#555" },
                style: {
                    stroke: "#555",  // arrow color
                    strokeWidth: 1.5,  // thickness (default is 1)
                }
            }
        )

        edges.push(
            {
                id: 'e3',
                source: 'parent',
                target: 'currentCompany',
                animated: true,
                arrowHeadType: 'arrowclosed',
                markerEnd: { type: MarkerType.Arrow, color: "#555" },
                style: {
                    stroke: "#555",  // arrow color
                    strokeWidth: 1.5,  // thickness (default is 1)
                }
            }
        )
    }

    return edges

    // return [
    //     // ...linkage.branches.map((_, index) => ({
    //     //     id: `e-branch-${index}`,
    //     //     source: 'currentCompany',
    //     //     target: `branch-${index}`,
    //     //     animated: true,
    //     //        markerEnd: { type: MarkerType.Arrow, color: "#555" },
    //     //        style: {
    //     //            stroke: "#555",  // arrow color
    //     //            strokeWidth: 1.5,  // thickness (default is 1)
    //     //        }
    //     // })),
    // ]
}

const CorporateLinkageGraph = ({
    domesticUltimate,
    globalUltimate,
    parent,
    currentCompany,
    t
}) => {
    return (
        <div style={{ height: 500, width: '100%' }}>
            <ReactFlow 
                nodes={generateNodes({
                    domesticUltimate,
                    globalUltimate,
                    parent,
                    currentCompany,
                    t
                })} 
                edges={generateEdges({
                    domesticUltimate,
                    parent
                })}
                nodesConnectable={false}
                nodesDraggable
                elementsSelectable
            >
                <MiniMap 
                    nodeStrokeColor={(n) => (n.style?.backgroundColor ? n.style.backgroundColor : "#eee")}
                    nodeColor={(node) => node.style.background}
                />
                <Controls />
                <Background color="#aaa" gap={16} />
            </ReactFlow>
        </div>
    );
}

export default withNamespaces()(
    CorporateLinkageGraph
);